module.exports = __webpack_public_path__ + "static/media/216.f0556e61.jpg";